import React from 'react';
import MyCard from '../../Common/MyCard';
import AddGroupeFonctionnalite from './AddGroupeFonctionnalite';
import ListeGroupeFonctionnalite from './ListeGroupeFonctionnalite';

const GroupeFonctionnalite = () => {
    return (
        <div>
            <MyCard
                titleCard="Groupe fonctionnalite"
                addComponent={<AddGroupeFonctionnalite />}
                content={<ListeGroupeFonctionnalite /> }
            />
        </div>
    );
}

export default GroupeFonctionnalite;
